module.exports = __webpack_public_path__ + "static/logo-lippo-group-108267c8ff7d5b33c45bddc0135faede.png";